import React, { Component } from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import notify from "devextreme/ui/notify";
import {
  criarRecursoDs,
  inserirOuAtualizar,
  criarSituacaoDividaDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import RecursoBox from "../recurso/RecursoBox.js";
import Memoria from "../../Memoria";
import List from "devextreme-react/list";
import api from "../../api-axios";
import UserInfo from "../../UserInfo";
import ContasBancariasBox from "../contasBancarias/ContasBancariasBox";
import { DataGrid, Column, Selection } from "devextreme-react/data-grid";
import { Paging } from "devextreme-react/tree-list";
import { CommonSeriesSettingsHoverStyle } from "devextreme-react/chart";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  paiId: undefined,
  modulo: undefined,
  nome: undefined,
  tipo: "3",
  linkFrontEnd: undefined,
  gruposPadrao: "",
  popupRecursoVisivel: false,
};

export default class RecursoForm extends Component {
  constructor(props) {
    super(props);
    this.renderRecurso = sysCodigoDescricao(
      () => this.state.recursoId.toString(),
      this.setRecursoId,
      () => this.state._uiRecurso.toString(),
      this.pesquisarRecurso
    );

    this.state = {
      ...(_cadastroCorrente || template),
      recursoId: "",
      _uiRecurso: "",
      grupos: [],
      gruposSelecionados: [],
      _uiGrupos: [],
    };

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.recursoDs = criarRecursoDs();
    this.pesquisarRecurso = this.pesquisarRecurso.bind(this);
    this.setRecursoId = this.setRecursoId.bind(this);
    this.RecursoBoxRef = React.createRef();

    this.tipoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: "1", descricao: "MENU" },
        { id: "2", descricao: "CONFIG" },
        { id: "3", descricao: "RECURSO" },
      ],
      valueExpr: "descricao",
      displayExpr: "descricao",
    };
  }

  async componentDidMount() {
    const gruposResponse = await api.get(
      "grupo_recursos/prefeitura/" + UserInfo.getPrefeitura()
    );

    console.log("resp grupos", gruposResponse);

    if (this.props.match.params.id != undefined) {
      const recursoResponse = await this.recursoDs.byKey(
        this.props.match.params.id
      );
      console.log("recurso", recursoResponse);

      let gruposIds = [];

      if (recursoResponse.gruposPadrao != undefined) {
        gruposIds = recursoResponse.gruposPadrao
          .split(",")
          .map((x) => x.trim())
          .map((x) => Number(x));
        gruposIds = gruposResponse.data.data.filter((x) =>
          gruposIds.includes(x.id)
        );
      }

      this.setState({
        ...recursoResponse,
        gruposSelecionados: gruposIds,
      });

      console.log(this.state);
    }

    var gruposTrimap = gruposResponse.data.data.filter((y) => y.gestor == "2");

    console.log("grupos trimap", gruposTrimap);

    this.setState({ ...this.state, grupos: gruposTrimap });
  }

  pesquisarRecurso = (e) => {
    this.setState({ popupRecursoVisivel: true });
  };

  setRecursoId(data) {
    this.setState({ recursoId: data.value });
    this.updateGrid(data.value, null);
  }

  onRecursoSelecionado = (e, entidadeDireta) => {
    let recurso = entidadeDireta;

    if (recurso == undefined && e && e.row && e.row.data) {
      recurso = e.row.data;
    }

    this.setState({
      ...this.state,
      recurso,
      recursoId: recurso.id,
      _uiRecurso: recurso.nome,
      popupRecursoVisivel: false,
    });
  };

  renderGrupos = () => {
    return (
      <div
        style={{
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: "lightgray",
        }}
      >
        <DataGrid
          dataSource={this.state.grupos}
          width={"100%"}
          selectionMode="multiple"
          showBorders={true}
          key={"id"}
          selectedRowKeys={this.state.gruposSelecionados}
          onSelectionChanged={(e) => {
            this.setState({
              ...this.state,
              gruposSelecionados: e.selectedRowsData,
            });
          }}
        >
          <Paging enabled={false} />
          <Column dataField={"nome"} caption={"Grupos"} />
          <Selection
            mode="multiple"
            selectAllMode="allPages"
            showCheckBoxesMode="always"
          />
        </DataGrid>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={9}>
              <GroupItem caption="Novo Recurso" colSpan={9} colCount={9}>
                <SimpleItem
                  dataField={"paiId"}
                  colSpan={7}
                  component={this.renderRecurso}
                >
                  <Label text="Recurso Pai" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"tipo"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoOptions}
                >
                  <Label text="Tipo" />
                </SimpleItem>
                <SimpleItem colSpan={3} dataField={"nome"}>
                  <Label text="Nome" />
                </SimpleItem>
                <SimpleItem colSpan={3} dataField={"modulo"}>
                  <Label text="Módulo" />
                </SimpleItem>
                <SimpleItem colSpan={3} dataField={"linkFrontEnd"}>
                  <Label text="Link" />
                </SimpleItem>
                <SimpleItem colSpan={9} render={this.renderGrupos}>
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupRecursoVisivel}
            onHiding={() => this.setState({ popupRecursoVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Recurso"
          >
            <ScrollView showScrollbar={"always"}>
              <RecursoBox
                onSelecionado={this.onRecursoSelecionado}
                ref={this.RecursoBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupRecursoVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const gruposFinal = [];

    this.state.gruposSelecionados.map((item) => {
      if (typeof item == "number") {
        gruposFinal.push(item);
      } else {
        gruposFinal.push(item.id);
      }
    });

    const entidade = {
      id: this.state.id,
      paiId: this.state.paiId,
      modulo: this.state.modulo,
      nome: this.state.nome,
      tipo: this.state.tipo,
      linkFrontEnd: this.state.linkFrontEnd,
      gruposPadrao: gruposFinal.join(","),
    };

    inserirOuAtualizar(this.recursoDs, entidade)
      .then(
        function () {
          notify("Recurso cadastrado com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          Memoria.removerEdicao(this.props.location);
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
